import { render, staticRenderFns } from "./vRecipeDetails.vue?vue&type=template&id=24ca461c&scoped=true"
import script from "./vRecipeDetails.vue?vue&type=script&lang=ts"
export * from "./vRecipeDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ca461c",
  null
  
)

export default component.exports